<template>
  <div id="app">
    <LoaderComponent ref="loader" />
    <header-component :properties="this.properties" />
    <router-view :properties="this.properties"></router-view>
    <footer-component/>
  </div>
</template>

<script>
import Vue from 'vue'
import HeaderComponent from "./components/HeaderComponent"
import FooterComponent from "./components/FooterComponent"
import LoaderComponent from "./components/LoaderComponent"
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    LoaderComponent
  },
  data() {
    return {
      properties: {
        'mobile': false,
        'sidebarMobile': false
      }
    }
  },
  mounted() {
    // document.querySelector('#main-preloader').remove()
    this.properties.sidebarMobile = window.innerWidth < 1100;
    this.properties.mobile = window.innerWidth < 720;
    window.addEventListener('resize', () => {
      this.properties.sidebarMobile = window.innerWidth < 1100;
      this.properties.mobile = window.innerWidth < 720;
    })
    const cookieLanguage = Vue.$cookies.get("language")
    if(cookieLanguage){
      this.$i18n.locale = cookieLanguage
    } else {
      Vue.$cookies.set("language", this.$root.$i18n.locale, '30d')
    }
    Vue.prototype.$loader = this.$refs.loader
    this.$refs.loader.hide()
    setTimeout(() => {
      document.querySelector('#main-preloader').remove()
    }, 2000)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue